import { IStatusPanelAngularComp } from 'ag-grid-angular';
import { IStatusPanelParams } from 'ag-grid-community';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';

import { OrderSelectionService } from '../../selection/order-selection.service';

@Component({
  selector: 'app-selected-order-count',
  templateUrl: './selected-order-count.component.html',
  styleUrls: ['./selected-order-count.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedOrderCountComponent
  implements IStatusPanelAngularComp, OnDestroy
{
  private selectionService = inject(OrderSelectionService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  private params!: IStatusPanelParams;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  selectedCount!: any;

  constructor() {
    this.selectionService.selectedRowsCountChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe((selection) => {
        this.selectedCount = selection;
        this.changeDetectorRef.markForCheck();
      });
  }

  agInit(params: IStatusPanelParams): void {
    this.params! = params;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
